var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _ellipse, _ellipse2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1127,
    height: 641,
    viewBox: "0 0 1127 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276 70.061C282 62.461 286.167 66.8943 287.5 70.061C290.7 75.261 299.833 83.561 304 87.061C306.8 100.661 291.5 123.728 283.5 133.561C283.5 145.561 301.167 156.894 310 161.061V169.061C286.4 161.061 252.167 203.394 238 225.561C208 188.561 215.5 167.061 223.5 142.561C229.9 122.961 261.167 86.061 276 70.061Z",
    fill: "#BAC3D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 96.561C372.1 106.161 344.5 101.894 332 98.561C339.6 113.361 360.167 122.061 369.5 124.561C368.3 139.761 354 153.561 347 158.561V166.561C361.8 166.161 376.833 193.728 382.5 207.561C409.3 155.961 393.667 112.061 382.5 96.561Z",
    fill: "#BAC3D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.5 69.561C397.5 43.561 369.622 -6.45683 325 4.56095C284.5 14.561 277.167 53.561 278.5 70.061C279.7 64.061 287.5 62.061 295.5 66.061C356.7 102.461 383 83.561 388.5 69.561ZM388.5 69.561C394.333 73.7277 401.3 85.061 382.5 97.061C363.7 109.061 324.333 96.7277 307 89.061C301.157 85.7277 288.476 76.461 284.5 66.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M329 4.56097C338.149 14.7876 352.615 44.705 337.286 82.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342 3.56097C350.539 13.8986 364.04 47.2943 349.733 85.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.5 135.061C298.167 158.728 339.1 189.961 369.5 125.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 118.561,
    r: 3,
    fill: "#BAC3D7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 121.561,
    r: 3,
    fill: "#BAC3D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307 111.561C307.833 109.561 311.2 105.861 318 107.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339 113.561C339.167 112.061 340.3 109.061 343.5 109.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322 149.009C324.947 149.653 331.874 150.265 336 147.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5 115.061C329.667 117.894 329.4 124.661 335 129.061C342 134.561 333 135.561 326 135.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311 161.612V167.715C319 171.203 337.2 175.475 346 164.664V158.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.5 168.561C293 169.061 251.4 187.861 225 259.061C221.667 268.728 221.4 291.061 247 303.061M252.5 281.061C243.667 330.394 228.1 433.161 236.5 449.561C244.9 465.961 360.667 453.061 417.5 444.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M414.5 445.061C422.5 444.061 424.5 441.561 419 432.061C412.053 420.061 396 372.561 400.5 333.061M387 221.061C380.5 203.394 363.4 167.461 347 165.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268 477.612C274.8 475.612 276.167 462.394 275.5 458.561H300C299.6 465.761 297.833 484.561 297 493.061C296.516 498 284.5 503.161 260.5 505.561C236.5 507.961 237.5 500.561 237.5 497.061C237.5 477.561 268.667 474.228 275.5 480.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M391 465.561C392.997 464.519 395.612 463.764 398.5 463.313M398.5 463.313C412.242 461.169 432.156 465.926 421 479.561C410.2 492.761 360.5 496 360.5 486.561L362 452.561L393 448.561C391.4 453.761 396 460.562 398.5 463.313Z",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280 265.061C284.8 264.661 284.667 267.561 284 269.061C282.167 273.561 275 282.461 261 282.061C247 281.661 242.833 272.561 242.5 268.061C246 245.061 265.5 237.061 267 237.061C268.5 237.061 283.5 232.061 284 237.061C284.4 241.061 278.833 242.061 276 242.061C272.167 242.728 265.252 245.061 268.852 251.061M264.5 271.561L281.5 264.061C284.167 263.394 288.8 260.961 286 256.561C283.2 252.161 272.833 258.394 268 262.061M268.852 251.306C274.686 248.239 287.6 244.299 286 254.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 207.561L286.5 217.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M694.5 202C696 203.667 702 204.961 712 202.561M710.5 202.895C712.333 205.062 719.9 206.761 727.5 201.561C735.1 196.361 734.333 190.728 733 188.561C732.774 188.141 732.44 187.704 732 187.321C734 182.33 731.613 178.401 730.17 177.061M719.528 192.061C717.519 189.894 715.2 184.961 722 182.561C725.682 181.261 728.358 179.121 730.17 177.061M733 172.561C732.618 173.631 731.703 175.317 730.17 177.061M691 178.061C693.4 172.061 702.333 165.228 706.5 162.561C713.5 158.228 729.3 150.861 736.5 156.061C739.167 158.061 741.7 162.761 730.5 165.561L723.5 167.061M709.5 176.561C710.167 180.561 709.2 190.061 700 196.061M725 167.061C728 166.228 733 167.061 733 172.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M732 187.061C729.5 187.228 722.4 189.761 714 196.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M700.5 168.061C702 169.228 706.6 171.361 713 170.561C721 169.561 721.5 175.061 720 177.561C718.8 179.561 713.833 179.061 711.5 178.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M503 316.561C497.658 320.835 483.648 327.513 467.5 323.076M464.5 314.561C458.9 316.961 461.833 320.561 463 321.561C464.515 322.167 466.016 322.668 467.5 323.076M467.5 323.076C467.5 318.238 469 309.061 475 311.061M475 316.561C476.667 311.394 481.5 302.061 487.5 306.061M484 314.561C485 311.228 488.4 305.661 494 310.061M492 315.561C494.167 312.389 499.4 307.749 503 314.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M505.5 474.061C506.333 475.561 507.1 480.061 503.5 486.061M508 488.561C499 485.728 470.5 488.561 478 509.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M531.5 471C535.5 480.667 538.2 500.9 517 504.5C495.8 508.1 479.5 513.5 478 509",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5 467.561C570.333 478.728 568.7 501.461 579.5 503.061C593 505.061 626.5 509.061 635.5 499.561C644.5 490.061 620.5 477.561 605 484.561M600.5 473.561C603.667 476.561 606.5 481.061 603 489.561",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M614.5 303C608.5 305.8 595.667 307.833 590 308.5L592 319.5C590.4 323.1 576.667 321 570 319.5C523.6 309.1 507 313.833 504.5 317.5C485 334.5 481.09 405.922 482 440.5C483 478.5 506.5 476.333 520.5 476C547.5 473.5 549.833 454.333 553 444.5C563 475.7 590.5 479.167 602.5 476C613.667 471 628.83 460.491 627.5 437C626 410.5 615.333 336.333 614.5 303Z",
    fill: "#BAC3D7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5 207C534.5 208.333 532.8 212 534 216",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M484 212.5C491.833 193.167 508 166 549 161.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M593.5 175C595.5 175.833 604.5 177.5 606 188.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5 176.5C692.333 176.833 704.7 183.3 691.5 206.5C678.3 229.7 633 248.5 612 255",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M611.5 255.181C613.167 266.681 613.5 292.381 611.5 305.181M689 177C681.167 175.5 655.1 175.181 633.5 187.181C627 190.515 613.7 196.6 606.5 189",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M534.758 115.242C545.396 109.429 551.566 118.972 553.321 124.47C568.041 115.152 572.24 79.6256 572.498 63.0272C591.164 76.0766 612.277 65.9392 620.5 59.2394C641.114 42.4438 634.521 26.6141 620.178 17.4883C611.832 12.1787 608.562 6.30298 606.809 1.88232C603.427 8.20016 600.977 19.0034 591.106 25.7504C586.209 29.0978 570.439 30.6494 562.223 33.2517C518.725 47.0288 525.789 93.6523 534.758 115.242Z",
    fill: "#BAC3D7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M534.923 113.884C532.237 119.96 530.247 135.067 546.133 138.769C547.924 144.574 555.97 157.022 573.827 160.37C596.149 164.555 611.64 161.351 618.892 155.08C626.144 148.808 635.121 132.738 634.968 118.131",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M626.897 117.661L638.002 116.074C639.856 114.27 643.305 107.366 635.467 106.09C632.619 105.841 626.254 104.448 623.575 100.87",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M620.271 59.0002C621.7 60.8101 624.455 65.6918 624.041 70.7401",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M584.985 94.8874C585.567 93.3677 587.469 89.7501 590.416 87.4371",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.474,
    cy: 100.292,
    rx: 2,
    ry: 3,
    transform: "rotate(-4.51193 605.474 100.292)",
    fill: "#BAC3D7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 632.364,
    cy: 85.1299,
    rx: 2,
    ry: 3,
    transform: "rotate(-4.51193 632.364 85.1299)",
    fill: "#BAC3D7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M611.114 101.853C611.733 109.7 606.886 115.729 601.21 116.177C595.534 116.625 589.801 111.43 589.182 103.584C588.563 95.7377 593.41 89.7085 599.086 89.2606C604.762 88.8127 610.495 94.007 611.114 101.853Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M635.932 85.8515C636.241 89.769 635.32 93.3139 633.699 95.8719C632.079 98.4292 629.867 99.8721 627.524 100.057C625.18 100.242 622.77 99.1638 620.768 96.8923C618.766 94.6201 617.3 91.2636 616.991 87.3462C616.682 83.4287 617.604 79.8838 619.224 77.3257C620.845 74.7685 623.056 73.3256 625.4 73.1407C627.743 72.9558 630.153 74.0339 632.155 76.3054C634.157 78.5775 635.623 81.934 635.932 85.8515Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M609.986 93.9175L616.65 89.3793",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M615.313 72.432C615.926 70.9661 617.919 68.024 620.98 67.9826",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M565.755 105.433L587.765 104.699",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M544.006 122.196C542.617 123.779 540.783 127.391 544.557 129.174",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M603.4 137.571C609.244 136.42 621.687 132.866 624.702 127.865",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M603.376 137.27C609.177 141.38 621.563 145.252 624.702 127.865",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M558.84 154.128C557.124 156.799 555.11 162.913 560.782 166C566.453 169.086 576.028 171.341 580.107 172.082C584.449 172.967 593.012 171.309 589.922 162.718",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M272 301.561C303.333 317.228 384.7 343.161 459.5 321.561M505 316.561C508.833 313.561 524.1 309.361 554.5 316.561C584.9 323.761 592.333 322.061 591.5 319.061C589.167 302.894 584.4 263.561 590 245.561C595.6 227.561 566.333 222.061 551 221.561C516 214.894 434 205.561 386 221.561C326 241.561 274.5 215.061 272 208.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M272 209.561C271.333 213.728 270.4 224.261 272 233.061M272 281.061C271.167 284.894 270 294.261 272 301.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M342 230.061C339.667 253.394 337.1 304.661 345.5 323.061M423.5 214.561C427.167 238.561 429 294.061 429 327.061M506.5 217.561C506.5 240.561 515.5 282.561 506.5 313.061",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3 330L12.5 349M18.5 343V327M28.5 343L37.5 330",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M372 613.5L384 630.5M392.5 630.5V610M401 630.5L413 610",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M854 342.5L872 356.5M883.5 356.5V325M895.5 356.5L909 336",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.83 461.162L1033.02 474.407C1032.41 476.516 1033.23 478.824 1035.22 479.758C1043.13 483.483 1050.51 481.916 1055.04 479.733C1056.92 478.83 1057.6 476.636 1057.01 474.644L1053.04 461.431C1052.74 460.411 1052.13 459.493 1051.22 458.938C1045.76 455.602 1040.85 457.213 1038.25 459.013C1037.52 459.517 1037.07 460.31 1036.83 461.162Z",
    fill: "#BAC3D7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1018 520.772L1025.1 496C1041.77 505.636 1058.06 500.015 1064.13 496L1071 520.772C1049.71 533.863 1026.8 526.226 1018 520.772Z",
    fill: "#BAC3D7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 565.583L1011.58 542C1037.26 556.02 1067.43 547.842 1079.3 542L1087 565.583C1051.99 584.449 1016.41 573.444 1003 565.583Z",
    fill: "#BAC3D7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M995.576 582.598L1000.44 572.662C992.11 576.342 973.715 584.718 966.812 588.78C959.908 592.843 963.935 598.127 966.812 600.262C989.012 612.037 1034.61 636.339 1039.39 639.342C1044.17 642.345 1049.64 640.593 1051.78 639.342C1071.32 629.112 1112.71 607.239 1121.92 601.586C1131.12 595.934 1125.75 590.252 1121.92 588.118L1089.83 572L1094.7 581.273C1096.91 588.118 1091.53 592.092 1089.39 594.079C1058.77 616.865 1018.96 604.898 1002.88 596.066C994.558 591.121 994.543 585.027 995.576 582.598Z",
    fill: "#BAC3D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcMaintenance);
export default __webpack_public_path__ + "static/media/oc-maintenance.95a79207386acea89abfd07e8568530a.svg";
export { ForwardRef as ReactComponent };